import { getCitiesService } from "../../services/cities/CitiesService";
// eslint-disable-next-line import/prefer-default-export
export const getCitiesAction = (params) => async (dispatch) => {
  const data = await getCitiesService(params);
  dispatch({ type: "SET_DATA_CITIES", payload: data });
};
